import type { GetModalParams, ModalType } from "@/modals/constructor"

type ModalMocks = { [K in ModalType]?: GetModalParams<K> }

// The surviving modals (pageLoading, settings, devTools) take no required
// params, so no mocks are needed. Add entries here as param-driven modals
// are introduced.
export const MODAL_MOCKS: ModalMocks = {}
